/**
 * El aviso de NIF repetido del diálogo de Clientes.
 *
 * Lo que es "el mismo NIF" lo decide el servidor (`nif_repetido.py`, con la misma
 * clave que la consulta de PayGold): aquí no se normaliza nada, solo se decide
 * cuándo preguntar y cómo contarlo.
 */

/**
 * Al dar de alta, siempre. Al editar, solo si se ha tocado el NIF: hay 50 fichas
 * que ya comparten NIF con otra, y avisarlas en cada guardado haría que el aviso
 * se dejara de leer.
 */
export function hayQueMirarNif({ creando, nuevo, original }) {
  const escrito = (nuevo || '').trim();
  if (!escrito) return false;
  return creando || escrito !== (original || '').trim();
}

/** "Bar Pepe (Bar Pepe SL) · Cliente, Baja" */
export function describirFicha(ficha) {
  const nombre = ficha.name || ficha.fiscal_name || 'Sin nombre';
  const fiscal = ficha.fiscal_name && ficha.fiscal_name !== nombre ? ` (${ficha.fiscal_name})` : '';
  const tipo = ficha.type === 'lead' ? 'Lead' : 'Cliente';
  return `${nombre}${fiscal} · ${ficha.status ? `${tipo}, ${ficha.status}` : tipo}`;
}

/** Lo que se pregunta al guardar. `fichas` null = no se ha podido comprobar. */
export function preguntaAlGuardar(fichas, creando) {
  const confirmText = creando ? 'Crear igualmente' : 'Guardar igualmente';
  if (fichas === null) {
    return {
      title: 'No se ha podido comprobar el NIF',
      description: 'No sé si este NIF ya está en otra ficha. Puedes guardar igualmente o volver a intentarlo.',
      confirmText,
    };
  }
  if (fichas.length === 0) return null;
  const lista = fichas.map((f) => `• ${describirFicha(f)}`).join('\n');
  return {
    title: fichas.length === 1 ? 'Este NIF ya está en otra ficha' : `Este NIF ya está en ${fichas.length} fichas`,
    description: `${lista}\n\nPuede ser correcto si es otro local de la misma empresa. Si es el mismo cliente, mejor abrir su ficha.`,
    confirmText,
  };
}
